
import BasePageView from "components/core/BasePageView/BasePageView";
import BidsList from "./BidsList";
import BidsListDesktopView from "./BidsListDesktopView";
import useBidsListLogic from "./useBidsListLogic";

const BidsListView = () => {
  const vm = useBidsListLogic();

  return (
    <BasePageView
      DesktopView={BidsListDesktopView}
      MobileView={BidsList}
      viewProps={vm}
    />
  );
};

export default BidsListView;
